import React from 'react'
import RaiseHand from '../../Components/PreCheckIllustrations/RaiseHand'

export default function StudentRaiseHand() {
    return (
        <div>
            <RaiseHand />
            <p>Please get your teacher. I can't hear you.</p>
        </div>
    )
}
